import {
    ThemeProvider,
    createTheme,
    CssBaseline,
    Box,
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Grid,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    LinearProgress,
    Avatar,
    Menu,
    MenuItem,
    useTheme,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
    UploadFile as UploadFileIcon,
   
  } from '@mui/icons-material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { useGetEmployeesQuery, useGetAllClockingsQuery, useGetAllBreaksQuery, useDeleteEmployeeMutation, useResetEmployeePinMutation, useUpdateEmployeeMutation, useCreateEmployeeMutation } from "../../state/api";

const PersonalInfo = () => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery('(max-width:768px)'); 

    return (
        <Box>
            <Paper sx={{ p: 4, borderRadius: '0.75rem' }}>
                <Typography variant="h4" gutterBottom>Personal Information</Typography>
                <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField fullWidth label="Full Name" defaultValue="Ibrahim Nuhu Ibrahim" variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth label="Titles (comma separated)" defaultValue="UX/UI DESIGNER, FULL STACK DEVELOPER, PENETRATION TESTER, ETC" variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth multiline rows={6} label="About Me Paragraph" defaultValue="A passionate and creative computer scientist with experience ranging across the full-stack software development environment..." variant="outlined" />
                </Grid>
                <Grid item xs={12} display="flex" alignItems="center" gap={2}>
                    <Button variant="contained" component="label" startIcon={<UploadFileIcon />}>
                    Upload Resume
                    <input type="file" hidden />
                    </Button>
                    <Typography variant="body2">current_resume.pdf</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" size="large">Save Changes</Button>
                </Grid>
                </Grid>
            </Paper>
        </Box>
    )

}

export default PersonalInfo;

